"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _default = /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  style: {
    display: 'inline-block',
    width: '1em',
    height: '1em',
    verticalAlign: 'middle',
    userSelect: 'none'
  }
}, /*#__PURE__*/React.createElement("path", {
  id: "ICO-Incomplete-time",
  d: "M6,12A6,6,0,0,1,.816,2.984C2.029,3.7,5.934,5.957,6,6V0A6,6,0,0,1,6,12Z",
  fill: "currentColor"
}));

exports["default"] = _default;
//# sourceMappingURL=incompleteTime.js.map